import React from "react";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";

function CheckoutLoadingSkeleton() {
  return (
    <MainPageWrapper hideHeader title="Checkout">
      <div className="animate-pulse space-y-6">
        <div className="mb-4">
          <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-32" />
        </div>
        <div className="space-y-2">
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/2" />
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
          <div className="flex gap-2">
            <div className="h-5 w-16 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="h-5 w-20 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="h-5 w-16 bg-gray-200 dark:bg-gray-700 rounded" />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1">
            <div className="border border-gray-200 dark:border-gray-700 rounded p-4 space-y-4">
              <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-32" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-2/3" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
              <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-1/2" />
            </div>
          </div>
          <div className="lg:col-span-2 space-y-6">
            <div className="border border-gray-200 dark:border-gray-700 rounded p-4 space-y-4">
              <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-32" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4" />
              <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/4" />
            </div>
            <div className="border border-gray-200 dark:border-gray-700 rounded p-4 space-y-4">
              <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-40" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-2/3" />
              <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-24" />
            </div>
            <div className="border border-gray-200 dark:border-gray-700 rounded p-4 space-y-4">
              <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-36" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full" />
              <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
            </div>
            <div className="border border-gray-200 dark:border-gray-700 rounded p-4 space-y-4">
              <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-48" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-2/3" />
              <div className="flex justify-end">
                <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded w-44" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainPageWrapper>
  );
}

export default CheckoutLoadingSkeleton;
